const gb = {
    "Bütün Kateqoriyalar": "All categories",
    "Kateqoriyalar": "Categories",
    "Kateqoriya": "Category",
    "Alətlər": "Tools",
    "Elektronika": "Electronics",
    "Nişan & Toy": "Engagement & Wedding",
    "Geyim": "Clothes",
    "Ev & Mətbəx": "Home & Kitchen",
    "Oyuncaqlar & Oyunlar": "Toys & Games",
    "İdman malları": "Sport",
    "Musiqi": "Music",
    "DVDS & Video oyunlar": "DVDs & Video games",
    "Qarışıq": "Miscellaneous",
    "Çanta": "Bag",
    "Velosiped": "Bicycle",
    "İdman Geyimi": "Sportwear",
    "5 AZN / həftəlik": "5 AZN / weekly",
    "15 AZN / həftəlik": "15 AZN / weekly",
    "20 AZN / həftəlik": "20 AZN / weekly",
    "ALMA!": "DON'T BUY",
    "Məhsulu axtarın..": "Search for an item..",
    "Məhsulu axtarın": "Search for an item",
    "İCARƏYƏ GÖTÜR": "RENT AN ITEM",
    "İcarəyə götür": "Rent an item",
    "İCARƏYƏ VER": "LIST AN ITEM",
    "İcarəyə ver": "List an item",
    "Hamısına Bax": "See All",
    "Bizi izləyin": "Follow us",
    "Bütün hüquqlar qorunur": "All rights reserved",
    "Günlük": "Daily",
    "Əsas səhifə": "Home page",
    "məhsul tapıldı": "item found",
    "Çeşidlə": "Sort By",
    "Qiymətə görə (əvvəlcə ucuz)": "Price (Low to High)",
    "Qiymətə görə (əvvəlcə bahalı)": "Price (High to Low)",
    "Hamısı": "All",
    "Qiymət": "Price",
    "Filtiri təmizlə": "Clear filters",
    "Yeni elan yerləşdir": "List a new item",
    "Siyahıdan seçin": "Choose from list",
    "Şəhər": "City",
    "Məzmun": "Description",
    "simvol qalıb": "symbols left",
    "Şəkillər": "Images",
    "Şəkil əlavə et": "Add an image",
    "Şəkilin ölçüsü 3096kb-dan çox olmamalıdır.": 
    "Size of an image should be less than 3096kb.",
    "Əlaqə məlumatları": "Contact info",
    "Adınız": "Name",
    "Mobil nömrə": "Mobile number",
    "Elanı yerləşdir": "List item",
    "Bağışlayın, seçdiyiniz kriteriya üzrə heç bir məhsul tapılmadı": 
    "Sorry, no products matching your search criteria were found",
    "Ətraflı Bax": "See details",
    "Axtar": "Search",
    "İcarə": "Rent",
    "Satış": "Buy",
    "Həftəlik": "Weekly",
    "Məsul şəxs": "Contact person",
    "Mobil": "Mobile number",
    "İcarə qiyməti": "Rent price",
    "Satış qiyməti": "Sale price",
};

export default gb;